// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './contexts/AuthContext';
import { ResumeProvider } from './contexts/ResumeContext';
import { JobTrackerProvider } from './contexts/JobTrackerContext';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Dashboard from './pages/Dashboard';
import Builder from './pages/Builder';
import Templates from './pages/Templates';
import Pricing from './pages/Pricing';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import PrivateRoute from './components/Auth/PrivateRoute';
import ResetPassword from './pages/ResetPassword';
import JDMatching from './pages/JDMatching';
import JobTracker from './pages/JobTracker';
import './styles/globals.css';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <ResumeProvider>
          <JobTrackerProvider>
            <div className="d-flex flex-column min-vh-100">
              <Navbar />
              <main className="flex-grow-1" style={{ paddingTop: '76px' }}>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/templates" element={<Templates />} />
                  <Route path="/pricing" element={<Pricing />} />

                  {/* ✅ ATS Job Matching - Active */}
                  <Route path="/jd-matching" element={
                    <PrivateRoute>
                      <JDMatching />
                    </PrivateRoute>
                  } />
                  
                  {/* ✅ Job Tracker - Active */}
                  <Route path="/job-tracker" element={
                    <PrivateRoute>
                      <JobTracker />
                    </PrivateRoute>
                  } />

                  {/* Protected Routes */}
                  <Route path="/dashboard" element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  } />
                  <Route path="/builder/:id?" element={
                    <PrivateRoute>
                      <Builder />
                    </PrivateRoute>
                  } />
                  
                  {/* 404 Redirect */}
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="top-right" />
          </JobTrackerProvider>
        </ResumeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;